var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Scrollbar',{staticClass:"h-full bg-neutral-200",attrs:{"overflowX":true}},[_c('div',{ref:"dagElement",class:{ 'cursor-wait': _vm.loading }},[_c('svg',{staticClass:"block m-4 text-center",class:{
                'graph-paper-bg bg-white border shadow-md border-neutral-300': !_vm.readonly,
                'pointer-events-none': _vm.loading,
            },attrs:{"id":"dagre"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }